import React from "react";
import { VFlexPropagate } from "./VFlexPropagate";

export class Container extends React.PureComponent {
    render() {
        const { full, ...props } = this.props;

        const boxProps = {
            ...props,
            px: props.px ?? (full ? undefined : 4)
        }

        return <VFlexPropagate { ...boxProps } />
    }
}